import React from 'react';
import EvaluatorPaymentItem from '../../../../Domain/EvaluatorPaymentItem';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import EvaluatorPaymentService from '../../../../Services/EvaluatorPaymentService';
import ApproveWindowDescription from './ApproveWindowDescription';
import EvaluatorPaymentActionParamsItem from './EvaluatorPaymentActionParamsItem';
import EvaluatorPaymentsSearchParams from './EvaluatorPaymentsSearchParams';
import VoidAndReissueWindowDescription from './VoidAndReissueWindowDescription';
import VoidWindowDescription from './VoidWindowDescription';
import VoidAndSupressWindowDescription from './VoidAndSupressWindowDescription';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import EditEvaluatorPaymentWindowDescription from './EditEvaluatorPaymentWindowDescription';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../../Enums/CrudTypesEnum';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import EditAdvancePaymentWindowDescription from './EditAdvancePaymentWindowDescription';
import InvoiceEvaluatorBaseService from '../../../../Services/InvoiceEvaluatorBaseService';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import PaymentRequestStatusChangeWindowDescription from './PaymentRequestStatusChangeWindowDescription';

export default class EvaluatorPaymentsBaseTab extends React.Component
{
  static defaultProps = { newButtonsEnabled: false };
  constructor (props)
  {
    super(props);

    const newSearchItem = new EvaluatorPaymentsSearchParams();
    newSearchItem.Type = this.getType();
    if (props.evaluatorId)
    {
      newSearchItem.EvaluatorId = props.evaluatorId;
    }

    if (props.ieAsId)
    {
      newSearchItem.IeAsId = props.ieAsId;
    }

    this.state = {
      searchItem: newSearchItem,
      shownPanel: ShownPanelsEnum.None,
      selected: -1,
      itemList: [],
      popup: null,
      allItemsInTheSearchSetAreSelected: false,
      isNewPaymentRequestEnabled: false,
      isNewAdvancePaymentEnabled: false,
      selectedItem: null,
    };

    this.startSearch = this.startSearch.bind(this);
    this.renderActionButtons = this.renderActionButtons.bind(this);
    EvaluatorPaymentItem.actionFunction = this.clickOnAction.bind(this);
    EvaluatorPaymentItem.editFunction = this.clickOnEdit.bind(this);
    EvaluatorPaymentItem.clickOnSelect = this.clickOnSelect.bind(this);
    EvaluatorPaymentItem.statusChangeFunction = this.statusChangeFunction.bind(this);
  }

  statusChangeFunction (item)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.StatusUpdate,
      selectedItem: item,
    });
  }

  clickOnSelect (item)
  {
    item.Selected = !item.Selected;
    this.setState({ itemList: [ ...this.state.itemList ] });
  }

  getSelectedIds ()
  {
    const selected = this.state.itemList.filter((item) => item.Selected === true);
    return selected.map((item) => item.IeId);
  }

  clickOnAction (ieIds, actionType)
  {
    let windowDescription = null;
    switch (actionType)
    {
      case 'Void':
        windowDescription = VoidWindowDescription;
        break;
      case 'VoidAndReissue':
        windowDescription = VoidAndReissueWindowDescription;
        break;
      case 'VoidAndSupress':
        windowDescription = VoidAndSupressWindowDescription;
        break;
      default:
        windowDescription = ApproveWindowDescription;
    }

    const paramsData = new EvaluatorPaymentActionParamsItem(
      ieIds,
      this.state.allItemsInTheSearchSetAreSelected,
      this.state.searchItem
    );

    this.setState({
      popup: (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={paramsData}
          clickOnCancel={() => this.setState({ popup: null })}
          clickOnSave={() => this.setState({ popup: null })}
          windowDescription={windowDescription}
          errorCode='CUA86'
        />
      ),
    });
  }

  clickOnEdit (invoiceEvaluator)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selected: invoiceEvaluator.IeId,
      selectedItem: invoiceEvaluator,
    });
  }

  startSearch (searchItem)
  {
    this.setState({
      searchItem,
    });
  }

  renderActionButtons ()
  {
    const disabled = !this.state.itemList.find((il) => il.Selected);
    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            iconName: 'fa-regular fa-check',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected).map((il) => il.IeId),
                'Approve'
              ),
            tooltip: 'Approve',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled,
          },
          {
            iconName: 'fa-regular fa-xmark',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected).map((il) => il.IeId),
                'Void'
              ),
            tooltip: 'Void',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled,
          },
          {
            iconName: 'fa-solid fa-rotate-right',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected).map((il) => il.IeId),
                'VoidAndReissue'
              ),
            tooltip: 'Void & Reissue',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled,
          },
          {
            iconName: 'fa-solid fa-trash',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected).map((il) => il.IeId),
                'VoidAndSupress'
              ),
            tooltip: 'Void & Supress',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled,
          },
        ]}
      />
    );
  }

  editPanelOnClose ()
  {
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  savePanelOnClose ()
  {
    if (this.state.shownPanel === ShownPanelsEnum.AddNewSubItem)
    {
      this.checkAdvancePaymentButtonAvailability();
    } else if (this.state.shownPanel === ShownPanelsEnum.AddNewItem)
    {
      this.checkNewPaymentRequestButtonAvailability();
    }

    this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
  }

  checkNewPaymentRequestButtonAvailability ()
  {
    this.setState({ isNewAdvancePaymentEnabled: false });
    InvoiceEvaluatorBaseService.IsNewPaymentRequestButtonEnabled(this.props.assignment.asId)
      .then((result) =>
      {
        this.setState({ isNewPaymentRequestEnabled: result });
      })
      .catch(() =>
      {
        ErrorMessage.SetErrorMessage('APT25');
      });
  }

  checkAdvancePaymentButtonAvailability ()
  {
    this.setState({ isNewAdvancePaymentEnabled: false });
    InvoiceEvaluatorBaseService.IsNewAdvancePaymentButtonEnabled(this.props.assignment.asId)
      .then((result) =>
      {
        this.setState({ isNewAdvancePaymentEnabled: result });
      })
      .catch(() =>
      {
        ErrorMessage.SetErrorMessage('EPBT198');
      });
  }

  renderPanels ()
  {
    if (this.state.shownPanel === ShownPanelsEnum.EditItem)
    {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={this.state.selectedItem}
          clickOnCancel={this.editPanelOnClose.bind(this)}
          clickOnSave={this.savePanelOnClose.bind(this)}
          windowDescription={EditEvaluatorPaymentWindowDescription}
          errorCode={'EPBT190'}
        />
      );
    } else if (this.state.shownPanel === ShownPanelsEnum.AddNewItem)
    {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Create}
          editedItem={
            new EvaluatorPaymentItem({
              asSassieAsgnId: this.props.assignment.asId,
              ieRcyName: this.props.assignment.ieRcyname,
              ieRcysymbol: this.props.assignment.ieRcysymbol,
            })
          }
          clickOnCancel={this.editPanelOnClose.bind(this)}
          clickOnSave={this.savePanelOnClose.bind(this)}
          windowDescription={EditEvaluatorPaymentWindowDescription}
        />
      );
    } else if (this.state.shownPanel === ShownPanelsEnum.AddNewSubItem)
    {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Create}
          editedItem={
            new EvaluatorPaymentItem({
              asSassieAsgnId: this.props.assignment.asId,
              ieRcyName: this.props.assignment.ieRcyName,
              ieRcysymbol: this.props.assignment.ieRcysymbol,
              evaluatorCurrencyId: this.props.assignment.evaluatorCurrencyId,
              asLdvname: this.props.assignment.asLdvname,
              cuCountry: this.props.assignment.cuCountry,
              ieTypeCode: '3',
              iePaymentTypeName: 'Check',
            })
          }
          clickOnCancel={this.editPanelOnClose.bind(this)}
          clickOnSave={this.savePanelOnClose.bind(this)}
          windowDescription={EditAdvancePaymentWindowDescription}
        />
      );
    } else if (this.state.shownPanel === ShownPanelsEnum.StatusUpdate)
    {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={{ ...this.state.selectedItem, Id: this.state.selectedItem.IeId, Comment: '' }}
          clickOnCancel={this.editPanelOnClose.bind(this)}
          clickOnSave={this.savePanelOnClose.bind(this)}
          windowDescription={PaymentRequestStatusChangeWindowDescription}
        />
      );
    }
  }

  render ()
  {
    return (
      <div className='contentwrapper'>
        {this.state.popup}
        {this.renderActionButtons()}
        {this.renderPanels()}
        <TabOfDataTable
          type={EvaluatorPaymentItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={EvaluatorPaymentService.GetEvaluatorPayments}
          convertDBItemsFunction={EvaluatorPaymentService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          showSearchStrip={true}
          searchParamsType={EvaluatorPaymentsSearchParams}
          clickOnStartSearch={this.startSearch}
          enableUrlPush={false}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) =>
          {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          errorCode='EPBT216'
        />
      </div>
    );
  }
}
